export const SCORES_ARRAY = ['score0', 'score1', 'score2', 'score3'];
